import { takeEvery, put } from 'redux-saga/effects';
import { apiClientActions, modalActions } from 'framework/actions';
import CONST from '../constants';

export default function* watchModalProductSearchOpen() {
  yield takeEvery(CONST.ACTION_MODAL_OPEN, process);
}

function* process() {
  // 1. Show Modal
  yield put(modalActions.createOpenModalAction(CONST.MODAL_NAME));

  // 2. Clear API data
  yield put(
    apiClientActions.clearApiClientStateAction({
      name: CONST.API_DATA_NAME
    })
  );
}
